module.exports = __webpack_public_path__ + "static/img/共享运营平台5.a7223e5b.png";